/**
 * HubManagedNotice (HP-34)
 *
 * HubPlatform holds the AI model settings of every product; while VitaHub syncs
 * them, the AI models and LLM Settings screens only show them and link to the
 * one place where they are changed.
 */
import { useTranslation } from 'react-i18next'
import { ArrowTopRightOnSquareIcon, InformationCircleIcon } from '@heroicons/react/24/outline'

const hostOf = (site) => {
  try {
    return new URL(site).host
  } catch {
    return site
  }
}

export default function HubManagedNotice({ site }) {
  const { t } = useTranslation()
  return (
    <div className="mt-3 rounded-md border border-primary-200 bg-primary-50 p-3 text-sm flex items-start gap-2"
      data-testid="hub-managed">
      <InformationCircleIcon className="h-5 w-5 flex-shrink-0 text-primary-700" aria-hidden="true" />
      <div>
        <p className="font-medium text-gray-900">{t('admin.hubManaged.title')}</p>
        <p className="text-gray-700">{t('admin.hubManaged.body')}</p>
        {site && (
          <a href={site} target="_blank" rel="noopener noreferrer"
            className="mt-1 inline-flex items-center gap-1 font-medium text-primary-700 underline"
            data-testid="hub-managed-link">
            {t('admin.hubManaged.link', { host: hostOf(site) })}
            <ArrowTopRightOnSquareIcon className="h-4 w-4" aria-hidden="true" />
          </a>
        )}
      </div>
    </div>
  )
}
